import { Directive, Input, Optional, AfterContentInit, ContentChild, ChangeDetectorRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ValidationMessageDirective } from './validation-message.directive';

@Directive({
  selector: 'validation-messages'
})
export class ValidationMessagesComponent implements AfterContentInit {
  @Input() control: FormControl;
  @Input() errorDescriptions: any = {};

  @ContentChild(ValidationMessageDirective) _errorMessage: ValidationMessageDirective;

  constructor(
    private _cdr: ChangeDetectorRef) {
  }

  ngAfterContentInit() {
    this.control.statusChanges.subscribe(s => {
      this._calculateMessagesVisibility();
    });
  }

  private _calculateMessagesVisibility() {
    if (this.control.invalid && this.control.dirty && this.control.errors) {
      const errKeys = Object.keys(this.control.errors);

      if (errKeys.length) {
        this._errorMessage.show(this._getValidationMessage(errKeys[0], this.control.errors[errKeys[0]]));
      }
      else
        this._errorMessage.hide();

    } else {
      this._errorMessage.hide();
    }

    this._cdr.markForCheck();
  }

  private _shouldShow() {
    return this.control.invalid && this.control.dirty && this.control.errors;
  }

  private _getValidationMessage(validatorName: string, validatorValue?: any): string {
    let messages: any = {};

    let getErrorDescriptionOrDefault = (defaultMessage: string) => {
      return this.errorDescriptions[validatorName] != undefined ? this.errorDescriptions[validatorName] : defaultMessage;
    }

    switch (validatorName) {
      case 'required':
        messages[validatorName] = getErrorDescriptionOrDefault('Requerido');
        break;

      case 'minlength':
        messages[validatorName] = getErrorDescriptionOrDefault(`Deber tener al menos ${validatorValue.requiredLength} caracteres`);
        break;

      case 'maxlength':
        messages[validatorName] = getErrorDescriptionOrDefault(`No pueder contener más de ${validatorValue.requiredLength} caracteres`);
        break;

      case 'email':
        messages[validatorName] = getErrorDescriptionOrDefault(`Ingresa una dirección de correo electrónico válida`);
        break;

      case 'onlyNumbers':
        messages[validatorName] = getErrorDescriptionOrDefault(`Introduce números únicamente`);
        break;

      case 'legalAge':
        messages[validatorName] = getErrorDescriptionOrDefault(`Debes de ser mayor de edad`);
        break;

      case 'pattern':
        messages[validatorName] = getErrorDescriptionOrDefault(`El formato no es válido`);
        break;

      default:
        messages[validatorName] = getErrorDescriptionOrDefault('El valor es inválido');
    }

    return messages[validatorName];
  }
}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/shared/forms/validation-messages.component.ts